<div class="overlay" *ngIf="open" (click)="close.emit()"></div>

<aside class="sidebar" [class.open]="open">
  <div class="sidebar-header">
    <img src="assets/logo.png" alt="Explora Vižula" />
    <button class="close-btn" (click)="close.emit()">✕</button>
  </div>

  <section class="section">
    <span style="font-size: 16px; font-weight: 600;">
      {{ 'SIDEBAR.LANGUAGE_TITLE' | translate }}
    </span>

    <p class="subtitle">
      {{ 'SIDEBAR.LANGUAGE_SUBTITLE' | translate }}
    </p>

    <button
      class="option lang"
      *ngFor="let lang of languages"
      [class.active]="lang.code === selectedLanguage"
      (click)="selectLanguage(lang.code)"
    >
      <span class="left">
        <img [src]="lang.flag" />
        <strong>{{ lang.labelKey | translate }}</strong>
      </span>
      <span class="radio"></span>
    </button>
  </section>

  <section class="section">
    <span style="font-size: 16px; font-weight: 600;">
      {{ 'SIDEBAR.AUDIO_TITLE' | translate }}
    </span>

    <p class="subtitle">
      {{ 'SIDEBAR.AUDIO_SUBTITLE' | translate }}
    </p>

    <button
      class="option"
      *ngFor="let mode of audioModes"
      [class.active]="mode.id === selectedAudioMode"
      (click)="selectAudioMode(mode.id)"
    >
      <span class="left">
        <img [src]="mode.icon" />
        <div>
          <strong>{{ mode.titleKey | translate }}</strong>
          <p style="font-size: 15px;">
            {{ mode.descKey | translate }}
          </p>
        </div>
      </span>
      <span class="radio"></span>
    </button>
  </section>
</aside>
